/**
 * Which sides supplied the used volume (`API-CONTRACT.md` §7). A THIN MOUNT of the one chip
 * primitive's `outcome` family — Phase 1's tokens already carry `max_of_both`, `orders_only`,
 * `forecast_only` and `blocked`; no second chip and no colour of this module's own.
 *
 * `outcome` is nullable on the wire: null renders an em-dash, never a default value.
 */
import { StateChip } from "../../../../components/common/StateChip";
import type { components } from "../../../../api/client";

export type SalesOutcome = NonNullable<components["schemas"]["SalesPlanningRow"]["outcome"]>;

export interface OutcomeChipProps {
  value: SalesOutcome | null | undefined;
}

export function OutcomeChip({ value }: OutcomeChipProps) {
  if (!value) return <span className="type-table text-muted-foreground">—</span>;
  return <StateChip family="outcome" value={value} />;
}
